import aa from "search-insights";

// Initialize Algolia Insights
aa("init", {
  appId: "HG2D4T2BH4",
  apiKey: "85a59320b86ffb9facc3912c3bb3064c",
});

export default aa;
